import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Sparkles, Heart, Leaf } from 'lucide-react';
export function AboutUs() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: Sparkles,
    title: 'Premium Products',
    color: 'bg-[#E8D5D5]'
  }, {
    icon: Heart,
    title: 'Personalized Care',
    color: 'bg-[#F5F0EB]'
  }, {
    icon: Leaf,
    title: 'Eco-Friendly',
    color: 'bg-[#C9A96E]/30'
  }];
  return <section id="about" className="py-24 bg-white relative overflow-hidden" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Image Grid */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="grid grid-cols-2 gap-4" data-id="element-14">
            <div className="space-y-4 mt-8" data-id="element-15">
              <img src="https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80&w=2070&auto=format&fit=crop" alt="Salon Detail" className="rounded-2xl w-full h-64 object-cover shadow-lg" data-id="element-16" />
              <img src="https://images.unsplash.com/photo-1522337660859-02fbefca4702?q=80&w=2069&auto=format&fit=crop" alt="Makeup Brushes" className="rounded-2xl w-full h-48 object-cover shadow-lg" data-id="element-17" />
            </div>
            <div className="space-y-4" data-id="element-18">
              <img src="https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?q=80&w=2072&auto=format&fit=crop" alt="Spa Treatment" className="rounded-2xl w-full h-48 object-cover shadow-lg" data-id="element-19" />
              <img src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?q=80&w=2070&auto=format&fit=crop" alt="Skincare Products" className="rounded-2xl w-full h-64 object-cover shadow-lg" data-id="element-20" />
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-21">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-[#3D3D3D] mb-6" data-id="element-22">
              {t.about.title}
            </h2>
            <div className="w-20 h-1 bg-[#C9A96E] mb-8" data-id="element-23" />

            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-24">
              {t.about.story}
            </p>
            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-25">
              {t.about.philosophy}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-26">
              {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center p-4 rounded-xl bg-[#FAF7F5]" data-id="element-27">
                  <div className={`p-3 rounded-full ${feature.color} mb-3`} data-id="element-28">
                    <feature.icon size={24} className="text-[#3D3D3D]" data-id="element-29" />
                  </div>
                  <span className="font-medium text-[#3D3D3D]" data-id="element-30">
                    {feature.title}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}